function getNewItem (id, item) {
  const newItem = {
    value: item.value || id,
    title: item.title || item
  }

  if (item.inactive) {
    newItem.inactive = item.inactive
  }
  if (item.slug) {
    newItem.slug = item.slug
  }
  if (item.browser_title) {
    newItem.browser_title = item.browser_title
  }
  if (item.meta_description) {
    newItem.meta_description = item.meta_description
  }

  return newItem
}

export default (data, filterTypes) => {
  const newData = {}
  filterTypes.forEach(filter => {
    const newItems = []
    for (const [id, item] of Object.entries(data[filter.listId])) {
      newItems.push(getNewItem(id, item))
    }
    newData[filter.listId] = newItems
  })
  return newData
}
